module.exports = __webpack_public_path__ + "img/ext10.fae15ef9.png";